import { ManagePayItems } from '../../../cimsPage/instances/payItems'
import { CreateViewEditSoftRemoveRestore, Simple } from '../../common'

const object = 'Pay Item Connection'

const groups = CreateViewEditSoftRemoveRestore({
  object: `${object} Group`,
  page: ManagePayItems,
  create: 'E5D8687B-451A-49DE-83B5-020A9088B44E',
  view: 'B6559ABA-60A5-40A3-B2F5-0CDBDBAFE6FF',
  edit: '50BB60E0-981C-4174-876E-77944FDFE4BA',
  removeRestore: 'F819D646-CAAE-4B94-9597-0E63A2041ACB',
})

const connections = CreateViewEditSoftRemoveRestore({
  object,
  page: ManagePayItems,
  create: '7746CECF-5D9E-417A-8AFA-48F78A23B8E1',
  view: 'F877598D-E47F-464B-8BF0-F3A93019F136',
  edit: 'B9E12A4D-A70C-4546-AB90-68CE780CB37E',
  removeRestore: 'FD01370D-F621-4355-8CAE-087FD7436898',
})

export const ViewPayItemConnectionGroup = groups.View
export const CreatePayItemConnectionGroup = groups.Create
export const EditPayItemConnectionGroup = groups.Edit
export const RemoveRestorePayItemConnectionGroup = groups.RemoveRestore
export const CreatePayItemConnection = connections.Create
export const ViewPayItemConnection = connections.View
export const EditPayItemConnection = connections.Edit
export const RemoveRestorePayItemConnection = connections.RemoveRestore
export const SyncPayItemConnection = Simple({
  action: 'Sync',
  page: ManagePayItems,
  id: '4F5E4177-9991-446C-8F00-920A4232B52F',
  object,
})

export type ManagePayItemsPermission =
  | typeof ViewPayItemConnectionGroup
  | typeof CreatePayItemConnectionGroup
  | typeof EditPayItemConnectionGroup
  | typeof RemoveRestorePayItemConnectionGroup
  | typeof CreatePayItemConnection
  | typeof ViewPayItemConnection
  | typeof EditPayItemConnection
  | typeof RemoveRestorePayItemConnection
  | typeof SyncPayItemConnection
